import { memo } from 'react'
import { isEqual } from 'lodash'
import HrmTradeUnionMemberManagementContainer from 'app/containers/HrmTradeUnionMemberManagement'
import { PageTitle } from 'app/components/common/PageTitle'
import { useTranslation } from 'react-i18next'
import R from 'app/assets/R'

const HrmTradeUnionMemberManagementCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.hrm_trade_union_members_management)}</PageTitle>
      <HrmTradeUnionMemberManagementContainer />
    </>
  )
}
export const HrmTradeUnionMemberManagementPage = memo(
  HrmTradeUnionMemberManagementCpn,
  isEqual,
)
